import { PoliceManifestationTraffic } from "../Model/PoliceManifestationTraffic";
import { v4 as v4uuid } from "uuid";
import { getCurrentUser } from "./session";
export class PoliceManifestationTrafficService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOneByDiligenceNumber(ndiligencia) {
        if (ndiligencia) {
            const response = await this.apiService.get('policemanifestationtraffic/' + ndiligencia);
            if (!response.ok) {
                throw new Error(`Error al obtener la extensión de tráfico manifestacion policial`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener nDiligencia`);
        }
    }
    async savePoliceManifestationTraffic(policeManifestation) {
        if (policeManifestation) {
            const response = await this.apiService.post('policemanifestationtraffic', policeManifestation);
            if (!response.ok) {
                throw new Error(`Error al guardar la la extensión de tráfico manifestación policial.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener la manifestación policial.`);
        }
    }
    async createPoliceManifestationTraffic(diligenceId) {
        if (diligenceId) {
            const policeManifestationTraffic = new PoliceManifestationTraffic({
                id: v4uuid(),
                diligenceNumber: diligenceId,
                crowdedLocation: " ",
                crowdedType: null,
                report: " ",
                sketch: null,
                sketchExplanation: " ",
                hourCommunicate: new Date(),
                arrivalTime: new Date(),
                communicantThird: null,
                signaling: " ",
                footprints: " ",
                observations: " ",
                userId: getCurrentUser().id,
                featuresVia: " ",
                characteristicsDay: " ",
                trafficAccident: false,
                preventiveControl: false,
                lostPoints: false,
                judicialDecision: false,
                notPossessPermission: false,
                vehicleImmobilization: false,
                qualifiedPerson: false,
                drivingAnomalies: " ",
                referralDate: new Date(),
                numFoliosRemision: 0,
                numMinutesRemision: 0,
                independentMinutes: " ",
                numcitations: 0,
                citations: " ",
                bodyTransfer: 0,
                ethylmeterSeries: null,
                dateCheckEthilometer: null
            });
            const response = await this.apiService.post('policemanifestationtraffic', policeManifestationTraffic.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciante de una diligencia trafico`);
            }
            return policeManifestationTraffic;
        }
        else {
            throw new Error(`Error al obtener el denunciante`);
        }
    }
}
